import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import 'login/components/Transaction/TransactionTimeSaved/TransactionTimeSaved.scss';

const TransactionTimeSaved = ({ effectiveTimeSavedSeconds }) => {
    return (
        <div className="TransactionTimeSaved--wrapper">
            <div className="TransactionTimeSaved--timer">{effectiveTimeSavedSeconds}</div>
            <div className="TransactionTimeSaved--label">{LocaleService.t('TRANSACTION_PROGRESSION.TIME_SAVED')}</div>
            <div className="TransactionTimeSaved--smiley">
                {effectiveTimeSavedSeconds !== '00:00' ? (
                    <icon className="icon-smiley-happy sr-sucessColor" />
                ) : (
                    <icon className="icon-smiley-mad" />
                )}
            </div>
        </div>
    );
};

TransactionTimeSaved.propTypes = {
    effectiveTimeSavedSeconds: PropTypes.string.isRequired,
};

TransactionTimeSaved.displayName = 'TransactionTimeSaved';

export default TransactionTimeSaved;
